import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import app from 'containers/app'
import * as OrgSelectors from 'app/modules/org/selectors'
import withNotifications from 'components/shared/notifications'
import { fetchOrg, fetchOrgProperties } from 'app/modules/org/actions'
import { refreshCurrentUser } from 'app/modules/user/actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button, Input } from '@driftt/tide-core-legacy'
import ACCESS from 'utils/Access'

import './style.styl'

class PardotIntegrationPage extends Component {

    constructor(props){
        super(props)
        this.state = {
            email: null,
            password:null,
            userKey: null
        }
    }

    static contextTypes = {
        router: PropTypes.object.isRequired
    }

    refreshProperties = () => {
        return this.props.actions.fetchOrgProperties()
    }

    refreshGates = () => {
        return this.props.actions.refreshCurrentUser()
    }

    onConnectClicked = () => {
        this.context.router.push('/settings/setup/pardot-config')
    }
    onEmailChange = (e) => {
        this.setState({
            email: e.target.value
        }, this.setConnectPayload)
        
    }
    onPasswordChange = (e) => {
        this.setState({
            password: e.target.value
        }, this.setConnectPayload)
    }
    onUserKeyChange = (e) => {
        this.setState({
            userKey: e.target.value
        }, this.setConnectPayload)
    }

    setConnectPayload = () => {
        const {email, password, userKey} = this.state
        if (!!email && !!password && !!userKey){
            this.props.setConnectPayload({ email, password, userKey })
        }
    }


    render() {
        const isConnected = this.props.data.installed
        return (
            <div className="pardot-integration-page">
                <p className="integration-page-description">
                    Using Pardot? Seamlessly add Drift in to your existing workflow.
                    With our integration you’ll enrich your team’s Drift experience by syncing Pardot contact information and pushing Drift leads into Pardot.
                </p>
                {!isConnected &&
                    <div>
                        <Input className="pardot-input" placeholder="Email" onChange={this.onEmailChange}/>
                        <Input className="pardot-input" placeholder="Password" type="password" onChange={this.onPasswordChange}/>
                        <Input placeholder="User Key" onChange={this.onUserKeyChange}/>
                    </div>
                }
                {isConnected &&
                    <Link to="/settings/pardot/config" className="integration-config-link">
                        <h2 className="integration-section-title">
                            Synced Pardot Data
                        </h2>
                        <p>Choose which data is sent between Pardot and Drift.</p>
                    </Link>
                }
                {isConnected && < Link to="/settings/pardot/mapping/attributes" className="integration-config-link">
                    <h2 className="integration-section-title">
                        Mapped Pardot Attributes
                    </h2>
                    <p>Map which fields you want to sync between Drift and Pardot.</p>
                </Link>
                }
                {(isConnected && ACCESS.hasGates('HAS_PARDOT_SYNC_LIST')) && (
                  <div className="integration-config-section">
                    <div>
                      <h2 className="integration-section-title">
                        Import Lists from Pardot
                      </h2>
                      <p>Sync Pardot Lists into Drift to use as segments.</p>
                    </div>
                    <Button type="tertiary" href="/contacts/imports" target="_blank">Go to Imports</Button>
                  </div>
                )}
                {isConnected &&
                    <Link to="/settings/pardot/event-log" className="integration-config-link">
                        View Pardot Event Log
                    </Link>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    orgProperties: OrgSelectors.properties(state),
})

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ fetchOrg, fetchOrgProperties, refreshCurrentUser }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(
    withNotifications(PardotIntegrationPage)
)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/PardotIntegrationPage/index.js